import { AppRoutes, pageTitles, sectionIds } from './constants';
import { PagesEnum } from './enums';
import { TSearchItem } from '../pages/Search/Search.types';
import { CourseEnum } from '../pages/CourseDetails/CourseDetails.enum';

export const mock: TSearchItem[] = [
  {
    type: 'section',
    path: AppRoutes.home,
    pageTitle: pageTitles[PagesEnum.Home],
    id: sectionIds[PagesEnum.Home].banner,
    keys: [
      {
        type: 'title',
        value: 'ОБРАЗОВАТЕЛЬНАЯ ПЛАТФОРМА',
      },
      {
        type: 'content',
        value: 'Учись. Развивайся. Достигай.',
      },
      {
        type: 'content',
        value: 'Начать бесплатно',
      },
    ],
  },
  {
    type: 'section',
    path: AppRoutes.home,
    sectionTitle: 'НАШИ БИЗНЕС-КУРСЫ',
    pageTitle: pageTitles[PagesEnum.Home],
    id: sectionIds[PagesEnum.Home].courses,
    keys: [
      {
        type: 'title',
        value: 'НАШИ БИЗНЕС-КУРСЫ',
      },
      {
        type: 'content',
        value: 'Бизнес-кэмп экспресс',
      },
      {
        type: 'content',
        value: 'Запусти бизнес с нуля или увеличь доход в своем деле за 1 месяц',
      },
      {
        type: 'content',
        value: 'Бизнес-кэмп базовый',
      },
      {
        type: 'content',
        value: 'Запусти бизнес с нуля или увеличь доход в своем деле за 2 месяц',
      },
      {
        type: 'content',
        value: 'Бизнес-кэмп продвинутый',
      },
      {
        type: 'content',
        value: 'Запусти бизнес с нуля или увеличь доход в своем деле за 3 месяц',
      },
    ],
  },
  {
    type: 'section',
    path: AppRoutes.home,
    sectionTitle: 'НАШ ИНСТРУМЕНТ',
    pageTitle: pageTitles[PagesEnum.Home],
    id: sectionIds[PagesEnum.Home].tools,
    keys: [
      {
        type: 'title',
        value: 'НАШ ИНСТРУМЕНТ',
      },
      {
        type: 'content',
        value: 'БЕСПЛАТНАЯ КОНСУЛЬТАЦИЯ',
      },
      {
        type: 'content',
        value:
          'Найди точки своего роста и составь пошаговый план увеличения дохода вместе с нашим экспертом',
      },
    ],
  },
  {
    type: 'section',
    path: AppRoutes.home,
    sectionTitle: 'НЕ ЗНАЕШЬ С ЧЕГО НАЧАТЬ?',
    pageTitle: pageTitles[PagesEnum.Home],
    id: sectionIds[PagesEnum.Home].consultation,
    keys: [
      {
        type: 'title',
        value: 'НЕ ЗНАЕШЬ С ЧЕГО НАЧАТЬ?',
      },
      {
        type: 'content',
        value: 'ЗАПИШИСЬ НА БЕСПЛАТНУЮ КОНСУЛЬТАЦИЮ',
      },
      {
        type: 'content',
        value:
          'Найди точки своего роста и составь пошаговый план увеличения дохода вместе с нашим экспертом',
      },
      {
        type: 'content',
        value: 'Сформируй цели',
      },
      {
        type: 'content',
        value: 'Определи точки своего роста',
      },
      {
        type: 'content',
        value: 'Составь план достижения целей',
      },
      {
        type: 'content',
        value: 'Оставить заявку',
      },
    ],
  },
  {
    type: 'section',
    path: AppRoutes.home,
    sectionTitle: 'Учиться онлайн – удобно',
    pageTitle: pageTitles[PagesEnum.Home],
    id: sectionIds[PagesEnum.Home].comfortability,
    keys: [
      {
        type: 'title',
        value: 'Учиться онлайн – удобно',
      },
      {
        type: 'content',
        value: 'Для тех, кто хочет открыть бизнес, но не знает, с чего начать',
      },
      {
        type: 'content',
        value:
          'Экономим время. Не теряй время на дорогу. Используй свое время эффективно – не нужно ездить на курсы, они сами приедут к тебе. Учись откуда удобно. Работа, дом, дача – наши эксперты там, где ты.',
      },
      {
        type: 'content',
        value:
          'Мотивируем на результат. Настраивайся на результат. С мотивацией нашей команды и заряжающей энергией группы у тебя все получится. Следи за своим прогрессом. Контроль твоих домашних заданий и обратная связь по твоему прогрессу.',
      },
      {
        type: 'content',
        value:
          'Экономим бюджет. Тебе не нужны учебные материалы. Для занятий нужен только Интернет и 120 минут твоего времени. Курсы по бюджету. Мы предлагаем курсы с разным бюджетом, чтобы ты выбрал наиболее подходящий тебе.',
      },
      {
        type: 'content',
        value: 'Для тех, кто открывал бизнес, но не достиг целей',
      },
      {
        type: 'content',
        value: 'Для тех, кто открыл бизнес и хочет масштаба',
      },
    ],
  },
  {
    type: 'section',
    path: AppRoutes.home,
    sectionTitle: 'Мы обеспечиваем лучшие условия',
    pageTitle: pageTitles[PagesEnum.Home],
    id: sectionIds[PagesEnum.Home].weProvideConditions,
    keys: [
      {
        type: 'title',
        value: 'МЫ ОБЕСПЕЧИВАЕМ ЛУЧШИЕ УСЛОВИЯ',
      },
      {
        type: 'content',
        value: 'Начни бесплатно',
      },
      {
        type: 'content',
        value: 'Получи персональный разбор на бесплатной консультации.',
      },
      {
        type: 'content',
        value: 'Плати частями',
      },
      {
        type: 'content',
        value: 'Не нужно платить за весь курс: плати частями на пакетах от 2 месяцев.',
      },
      {
        type: 'content',
        value: 'Занимайся со скидкой',
      },
      {
        type: 'content',
        value: 'Получи скидку на покупку больших пакетов.',
      },
      {
        type: 'content',
        value: 'Получи выгоду',
      },
      {
        type: 'content',
        value: 'Пригласи друга и мы сделаем вам обоим по 10% скидки.',
      },
      {
        type: 'content',
        value: 'Безопасность платежей',
      },
      {
        type: 'content',
        value: 'Защищаем платежи технологией HTTPS и двухфакторной аутентификацией 3D Secure.',
      },
      {
        type: 'content',
        value: 'Прозрачный баланс',
      },
      {
        type: 'content',
        value: 'Отображаем баланс твоих платежей.',
      },
    ],
  },
  {
    type: 'section',
    path: AppRoutes.home,
    sectionTitle: 'Отбираем лучших экспертов',
    pageTitle: pageTitles[PagesEnum.Home],
    id: sectionIds[PagesEnum.Home].experts,
    keys: [
      {
        type: 'title',
        value: 'ОТБИРАЕМ ЛУЧШИХ ЭКСПЕРТОВ',
      },
      {
        type: 'content',
        value: 'Профильное образование',
      },
      {
        type: 'content',
        value: 'Все эксперты обладают высшим профильным образованием лучших университетов.',
      },
      {
        type: 'content',
        value: 'Методика обучения',
      },
      {
        type: 'content',
        value:
          'Обучение построено по практической методике. Ты начнешь практиковаться на первом занятии.',
      },
      {
        type: 'content',
        value: 'Практический опыт',
      },
      {
        type: 'content',
        value:
          'Каждый эксперт имеет практический опыт в своей нише, может поделиться своими успехами и неудачами.',
      },
    ],
  },
  {
    type: 'section',
    path: AppRoutes.home,
    sectionTitle: 'Ты сам выбираешь свое будущее',
    pageTitle: pageTitles[PagesEnum.Home],
    id: sectionIds[PagesEnum.Home].yourFuture,
    keys: [
      {
        type: 'title',
        value: 'ТЫ САМ ВЫБИРАЕШЬ СВОЕ БУДУЩЕЕ',
      },
      {
        type: 'content',
        value: 'Не сиди дома, обесценивая себя',
      },
      {
        type: 'content',
        value: 'Не забивай голову успехами других',
      },
      {
        type: 'content',
        value: 'Проживай свою собственную жизнь',
      },
    ],
  },
  {
    type: 'section',
    path: AppRoutes.home,
    sectionTitle: 'Команда',
    pageTitle: pageTitles[PagesEnum.Home],
    id: sectionIds[PagesEnum.Home].team,
    keys: [
      {
        type: 'title',
        value: 'КОМАНДА',
      },
      {
        type: 'content',
        value: 'Управление',
      },
      {
        type: 'content',
        value: 'Инновационные методы управления с применением цифровых технологий.',
      },
      {
        type: 'content',
        value: 'Методисты',
      },
      {
        type: 'content',
        value: 'В школе работают профессионалы с научно-методическим опытом.',
      },
      {
        type: 'content',
        value: 'Платформа',
      },
      {
        type: 'content',
        value: 'Платформа SkyBox и цифровые материалы обеспечивают эффективный способ обучения.',
      },
    ],
  },
  {
    type: 'section',
    path: AppRoutes.home,
    sectionTitle: 'Наши ценности',
    pageTitle: pageTitles[PagesEnum.Home],
    id: sectionIds[PagesEnum.Home].carousel,
    keys: [
      {
        type: 'title',
        value: 'НАШИ ЦЕННОСТИ',
      },
      {
        type: 'content',
        value: 'Честность',
      },
      {
        type: 'content',
        value: 'оказание качественных услуг наш приоритет',
      },
      {
        type: 'content',
        value: 'Качество',
      },
      {
        type: 'content',
        value: 'мы честны с каждым учеником',
      },
      {
        type: 'content',
        value: 'Результат',
      },
      {
        type: 'content',
        value: 'мы ориентируемся на результат каждого ученика',
      },
      {
        type: 'content',
        value: 'Прогресс',
      },
      {
        type: 'content',
        value: 'мы следим за прогрессом наших учеников',
      },
      {
        type: 'content',
        value: 'Цель',
      },
      {
        type: 'content',
        value: 'мы помогаем ученикам добиваться своих целей',
      },
      {
        type: 'content',
        value: 'Мотивация',
      },
      {
        type: 'content',
        value: 'мы изучаем типы личностей и мотивируем учеников',
      },
    ],
  },

  // - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - School page
  {
    type: 'section',
    path: AppRoutes.school,
    pageTitle: pageTitles[PagesEnum.School],
    id: sectionIds[PagesEnum.School].hero,
    keys: [
      {
        type: 'title',
        value: 'ШКОЛА ПРЕДПРИНИМАТЕЛЯ',
      },
      {
        type: 'content',
        value: 'с нами ты откроешь свой бизнес',
      },
      {
        type: 'content',
        value: 'Получи бесплатную консультацию',
      },
      {
        type: 'content',
        value: 'Определи свою нишу',
      },
      {
        type: 'content',
        value: 'Составь план достижения целей',
      },
      {
        type: 'content',
        value: 'Открой свой бизнес',
      },
    ],
  },
  {
    type: 'section',
    path: AppRoutes.school,
    sectionTitle: 'НАШ ИНСТРУМЕНТ',
    pageTitle: pageTitles[PagesEnum.School],
    id: sectionIds[PagesEnum.School].tools,
    keys: [
      {
        type: 'title',
        value: 'НАШ ИНСТРУМЕНТ',
      },
      {
        type: 'content',
        value: 'БЕСПЛАТНАЯ КОНСУЛЬТАЦИЯ',
      },
      {
        type: 'content',
        value:
          'Найди точки своего роста и составь пошаговый план увеличения дохода вместе с нашим экспертом',
      },
    ],
  },
  {
    type: 'section',
    path: AppRoutes.school,
    sectionTitle: 'НЕ ЗНАЕШЬ С ЧЕГО НАЧАТЬ?',
    pageTitle: pageTitles[PagesEnum.School],
    id: sectionIds[PagesEnum.School].consultation,
    keys: [
      {
        type: 'title',
        value: 'НЕ ЗНАЕШЬ С ЧЕГО НАЧАТЬ?',
      },
      {
        type: 'content',
        value: 'ЗАПИШИСЬ НА БЕСПЛАТНУЮ КОНСУЛЬТАЦИЮ',
      },
      {
        type: 'content',
        value:
          'Найди точки своего роста и составь пошаговый план увеличения дохода вместе с нашим экспертом',
      },
      {
        type: 'content',
        value: 'Сформируй цели',
      },
      {
        type: 'content',
        value: 'Определи точки своего роста',
      },
      {
        type: 'content',
        value: 'Составь план достижения целей',
      },
      {
        type: 'content',
        value: 'Оставить заявку',
      },
    ],
  },
  {
    type: 'section',
    path: AppRoutes.school,
    sectionTitle: 'НАШИ ЭКСПЕРТЫ',
    pageTitle: pageTitles[PagesEnum.School],
    id: sectionIds[PagesEnum.School].ourExperts,
    keys: [
      {
        type: 'title',
        value: 'НАШИ ЭКСПЕРТЫ',
      },
      {
        type: 'content',
        value: 'Действуй вместе с нами!',
      },
      {
        type: 'content',
        value: 'Аршак Заргарян',
      },
      {
        type: 'content',
        value: 'кандидат экономических наук, специализация «малое предпринимательство»',
      },
      {
        type: 'content',
        value: 'опыт работы со студентами по запуску бизнес-проектов (11 лет)',
      },
      {
        type: 'content',
        value: 'высокая мотивация на результат и контроль за прогрессом',
      },
      {
        type: 'content',
        value: '«великие дела нужно совершать, а не обдумывать бесконечно»',
      },
      {
        type: 'content',
        value: 'Поможем открыть собственный бизнес',
      },
    ],
  },
  {
    type: 'section',
    path: AppRoutes.school,
    sectionTitle: 'Зачем создавать собственный бизнес?',
    pageTitle: pageTitles[PagesEnum.School],
    id: sectionIds[PagesEnum.School].ownBusiness,
    keys: [
      {
        type: 'title',
        value: 'ЗАЧЕМ СОЗДАВАТЬ СОБСТВЕННЫЙ БИЗНЕС?',
      },
      {
        type: 'content',
        value: 'Бизнес создают те, кто ставит цели без границ и думает о своем будущем',
      },
      {
        type: 'content',
        value: 'Пройди обучение. Не бойся того, что не получится, бойся того, что не пробуешь.',
      },
      {
        type: 'content',
        value:
          'Поставь бизнес-цели. Определись со своими бизнес-целями, нарисуй кем ты себя видишь через год.',
      },
      {
        type: 'content',
        value:
          'Найди то, что подходит тебе. Будь открыт, не бойся задавать вопросы, это поможет тебе найти свое дело.',
      },
      {
        type: 'content',
        value:
          'Проверь свою гипотезу. Протестируй свои идеи, прежде чем начать рисковать. Ты сэкономишь свое время и деньги.',
      },
      {
        type: 'content',
        value:
          'Запусти первые продажи. Определи боли своего клиента, предложи решение. Он это оценит, а ты заработаешь.',
      },
      {
        type: 'content',
        value:
          'Закрой жизненные цели. Достигни целей в бизнесе, реализуй свои жизненные цели, исполни мечты.',
      },
    ],
  },
  {
    type: 'section',
    path: AppRoutes.school,
    sectionTitle: 'КАКИЕ ЭТАПЫ ТЫ ПРОЙДЕШЬ?',
    pageTitle: pageTitles[PagesEnum.School],
    id: sectionIds[PagesEnum.School].businessPhases,
    keys: [
      {
        type: 'title',
        value: 'КАКИЕ ЭТАПЫ ТЫ ПРОЙДЕШЬ?',
      },
      {
        type: 'content',
        value: 'Определишь свою рыночную нишу',
      },
      {
        type: 'content',
        value: 'Найдешь бизнес-идею и сформулируешь свою гипотезу',
      },
      {
        type: 'content',
        value: 'Проверишь гипотезу и упакуешь свой продукт',
      },
      {
        type: 'content',
        value: 'Подберешь людей и соберешь свою команду',
      },
      {
        type: 'content',
        value: 'Научишься привлекать первых клиентов',
      },
      {
        type: 'content',
        value: 'Построишь свою финансовую систему',
      },
      {
        type: 'content',
        value: 'Закроешь свои бизнес-цели',
      },
    ],
  },

  // - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - Courses page
  {
    type: 'section',
    path: AppRoutes.courses,
    sectionTitle: 'ДЛЯ КОГО НАШИ БИЗНЕС-КУРСЫ?',
    pageTitle: pageTitles[PagesEnum.Courses],
    id: sectionIds[PagesEnum.Courses].ourAuditorium,
    keys: [
      {
        type: 'title',
        value: 'ДЛЯ КОГО НАШИ БИЗНЕС-КУРСЫ?',
      },
      {
        type: 'content',
        value: 'Для тех, кто хочет открыть бизнес, но не знает, с чего начать',
      },
      {
        type: 'content',
        value: 'Для тех, кто открывал бизнес, но не достиг целей',
      },
      {
        type: 'content',
        value: 'Для тех, кто открыл бизнес и хочет масштаба',
      },
    ],
  },

  // - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - Course Details page
  {
    type: 'section',
    path: `${AppRoutes.courses}/${CourseEnum.Advanced}`,
    sectionTitle: 'БИЗНЕС-КЭМП ПРОДВИНУТЫЙ',
    pageTitle: pageTitles[PagesEnum.CourseDetails],
    id: sectionIds[PagesEnum.CourseDetails].courseHero,
    keys: [
      {
        type: 'title',
        value: 'БИЗНЕС-КЭМП ПРОДВИНУТЫЙ',
      },
      {
        type: 'content',
        value: 'Запусти бизнес с нуля или увеличь доход в своем деле за 3 месяца',
      },
    ],
  },
  {
    type: 'section',
    path: `${AppRoutes.courses}/${CourseEnum.Advanced}`,
    sectionTitle: 'ЧТО ТЫ ПОЛУЧИШЬ?',
    pageTitle: pageTitles[PagesEnum.CourseDetails],
    id: sectionIds[PagesEnum.CourseDetails].benefits,
    keys: [
      {
        type: 'title',
        value: 'ЧТО ТЫ ПОЛУЧИШЬ?',
      },
      {
        type: 'content',
        value: 'Выберешь и проверишь свою нишу',
      },
      {
        type: 'content',
        value: 'Проанализируешь рынок',
      },
      {
        type: 'content',
        value: 'Разработаешь MPV',
      },
      {
        type: 'content',
        value: 'Подберешь команду',
      },
      {
        type: 'content',
        value: 'Создашь точки контакта',
      },
      {
        type: 'content',
        value: 'Настроишь клиентский поток',
      },
      {
        type: 'content',
        value: 'Разработаешь полноценный продукт',
      },
      {
        type: 'content',
        value: 'Построишь систему продаж',
      },
      {
        type: 'content',
        value: 'Сформируешь бизнес-систему',
      },
      {
        type: 'content',
        value: 'Начнешь масштабироваться',
      },
    ],
  },
  {
    type: 'section',
    path: `${AppRoutes.courses}/${CourseEnum.Advanced}`,
    sectionTitle: 'ДЛЯ КОГО ЭТОТ КУРС?',
    pageTitle: pageTitles[PagesEnum.CourseDetails],
    id: sectionIds[PagesEnum.CourseDetails].courseAuditorium,
    keys: [
      {
        type: 'title',
        value: 'ДЛЯ КОГО ЭТОТ КУРС?',
      },
      {
        type: 'content',
        value: 'НОВИЧКИ',
      },
      {
        type: 'content',
        value: 'Хочешь свое дело, но не знаешь, с чего начать?',
      },
      {
        type: 'content',
        value: 'Не понимаешь, чем хочешь заниматься?',
      },
      {
        type: 'content',
        value: 'Боишься, что не справишься с запуском бизнеса в одиночку?',
      },
      {
        type: 'content',
        value: 'С НАМИ ТЫ',
      },
      {
        type: 'content',
        value: 'Выберешь нишу и упакуешь продукт',
      },
      {
        type: 'content',
        value: 'Заработаешь первые деньги и вырастешь в доходе',
      },
      {
        type: 'content',
        value: 'Получишь персональное сопровождение на всех этапах: от старта до масштабирования',
      },
      {
        type: 'content',
        value: 'ОПЫТНЫЕ',
      },
      {
        type: 'content',
        value: 'Ты вкалываешь без выходных, но не видишь результата?',
      },
      {
        type: 'content',
        value: 'Твоя прибыль не растет, и ты не знаешь, как сдвинуться с места?',
      },
      {
        type: 'content',
        value: 'Хочешь выйти на новый уровень, но не понимаешь как?',
      },
      {
        type: 'content',
        value: 'С НАМИ ТЫ',
      },
      {
        type: 'content',
        value: 'Найдешь точки роста и получишь новые инструменты для заработка',
      },
      {
        type: 'content',
        value: 'Получишь свежие идеи для развития своего бизнеса',
      },
      {
        type: 'content',
        value: 'Масштабируешь бизнес и увеличишь доход',
      },
    ],
  },
  {
    type: 'section',
    path: `${AppRoutes.courses}/${CourseEnum.Advanced}`,
    sectionTitle: 'ЧТО ТЕБЯ ЖДЕТ?',
    pageTitle: pageTitles[PagesEnum.CourseDetails],
    id: sectionIds[PagesEnum.CourseDetails].upcomingSteps,
    keys: [
      {
        type: 'title',
        value: 'ЧТО ТЕБЯ ЖДЕТ?',
      },
      {
        type: 'content',
        value: 'Модуль 1. Формирование целей',
      },
      {
        type: 'content',
        value: 'Определишь цель и сформируешь план действий',
      },
      {
        type: 'content',
        value: 'Прокачаешь мышление предпринимателя',
      },
      {
        type: 'content',
        value: 'Проработаешь ключевые навыки предпринимателя',
      },
      {
        type: 'content',
        value: 'Твой результат: Сформулируешь свои цели',
      },
      {
        type: 'content',
        value: 'Модуль 2. Выбор своего дела',
      },
      {
        type: 'content',
        value: 'Проанализируешь свои интересы, навыки и компетенции',
      },
      {
        type: 'content',
        value: 'Узнаешь, как найти бизнес-идею',
      },
      {
        type: 'content',
        value: 'Узнаешь, как протестировать бизнес-идею',
      },
      {
        type: 'content',
        value: 'Твой результат: Выберешь свое дело',
      },
      {
        type: 'content',
        value: 'Модуль 3. Анализ рынка',
      },
      {
        type: 'content',
        value: 'Узнаешь, как оценить объем рынка',
      },
      {
        type: 'content',
        value: 'Узнаешь, как оценить конкурентов',
      },
      {
        type: 'content',
        value: 'Узнаешь, как оценить потребителей',
      },
      {
        type: 'content',
        value: 'Твой результат: Проанализируешь свои рынки',
      },
      {
        type: 'content',
        value: 'Модуль 4. Разработка MVP',
      },
      {
        type: 'content',
        value: 'Узнаешь, как создать продукт с минимальным функционалом',
      },
      {
        type: 'content',
        value: 'Узнаешь, как рассчитать юнит-экономику',
      },
      {
        type: 'content',
        value: 'Узнаешь, как избежать ошибок на старте',
      },
      {
        type: 'content',
        value: 'Твой результат: Разработаешь свой MVP',
      },
      {
        type: 'content',
        value: 'Модуль 5. Подбор команды',
      },
      {
        type: 'content',
        value: 'Начнешь искать и нанимать сотрудников',
      },
      {
        type: 'content',
        value: 'Научишься руководить персоналом',
      },
      {
        type: 'content',
        value: 'Узнаешь, как создать результативный личный бренд',
      },
      {
        type: 'content',
        value: 'Твой результат: Подберешь свою команду',
      },
      {
        type: 'content',
        value: 'Модуль 6. Создание точек контакта',
      },
      {
        type: 'content',
        value: 'Создашь точки контакта клиентов с продуктом',
      },
      {
        type: 'content',
        value: 'Разработаешь план маркетинга',
      },
      {
        type: 'content',
        value: 'Начнешь привлекать клиентов',
      },
      {
        type: 'content',
        value: 'Твой результат: Создашь свои точки контакта',
      },
    ],
  },

  // - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - Free Consultation page
  {
    type: 'section',
    path: AppRoutes.freeConsultation,
    sectionTitle: 'Бесплатная консультация',
    pageTitle: pageTitles[PagesEnum.FreeConsultation],
    id: sectionIds[PagesEnum.FreeConsultation].individualCasting,
    keys: [
      {
        type: 'title',
        value: 'БЕСПЛАТНАЯ КОНСУЛЬТАЦИЯ',
      },
      {
        type: 'content',
        value: 'ИНДИВИДУАЛЬНЫЙ РАЗБОР С ЭКСПЕРТОМ',
      },
      {
        type: 'content',
        value: 'За 60 минут с экспертом ты:',
      },
      {
        type: 'content',
        value: 'разберешь свою ситуацию, определишь сильные и слабые стороны',
      },
      {
        type: 'content',
        value: 'увидишь возможности для увеличения дохода',
      },
      {
        type: 'content',
        value: 'получишь четкий план своего развития',
      },
      {
        type: 'content',
        value: 'получишь конкретные ответы на свои вопросы',
      },
      {
        type: 'content',
        value: 'Записаться',
      },
      {
        type: 'content',
        value: 'Все это действительно бесплатно!',
      },
    ],
  },
  {
    type: 'section',
    path: AppRoutes.freeConsultation,
    sectionTitle: 'ИДЕАЛЬНО ДЛЯ ТЕХ, КТО ХОЧЕТ',
    pageTitle: pageTitles[PagesEnum.FreeConsultation],
    id: sectionIds[PagesEnum.FreeConsultation].idealMatch,
    keys: [
      {
        type: 'title',
        value: 'ИДЕАЛЬНО ДЛЯ ТЕХ, КТО ХОЧЕТ',
      },
      {
        type: 'content',
        value: 'Начать больше зарабатывать, но не знает как',
      },
      {
        type: 'content',
        value: 'Открыть свое дело, но не понимает, с чего начать',
      },
      {
        type: 'content',
        value: 'Найти бизнес-идею и проанализировать риски',
      },
      {
        type: 'content',
        value: 'Составить план запуска бизнеса и сделать первый шаг',
      },
    ],
  },
  {
    type: 'section',
    path: AppRoutes.freeConsultation,
    sectionTitle: 'РАЗБОР – ЭТО',
    pageTitle: pageTitles[PagesEnum.FreeConsultation],
    id: sectionIds[PagesEnum.FreeConsultation].parsing,
    keys: [
      {
        type: 'title',
        value: 'РАЗБОР – ЭТО',
      },
      {
        type: 'content',
        value: 'ZOOM. Встреча в Zoom',
      },
      {
        type: 'content',
        value: '60 МИНУТ. 60 минут общения с экспертом',
      },
      {
        type: 'content',
        value: 'ЦЕЛИ. Разбор твоей ситуации и постановка целей',
      },
    ],
  },
  {
    type: 'section',
    path: AppRoutes.freeConsultation,
    sectionTitle: 'В РЕЗУЛЬТАТЕ ТЫ:',
    pageTitle: pageTitles[PagesEnum.FreeConsultation],
    id: sectionIds[PagesEnum.FreeConsultation].inResult,
    keys: [
      {
        type: 'title',
        value: 'В РЕЗУЛЬТАТЕ ТЫ:',
      },
      {
        type: 'content',
        value: 'Сформируешь свои бизнес-цели',
      },
      {
        type: 'content',
        value: 'Определишь направления запуска бизнеса',
      },
      {
        type: 'content',
        value: 'Составишь поэтапный план действий',
      },
    ],
  },
  {
    type: 'section',
    path: AppRoutes.freeConsultation,
    sectionTitle: 'РАЗБОР ПРОВЕДЕТ УНИВЕРСАЛЬНЫЙ ЭКСПЕРТ',
    pageTitle: pageTitles[PagesEnum.FreeConsultation],
    id: sectionIds[PagesEnum.FreeConsultation].universalExpert,
    keys: [
      {
        type: 'title',
        value: 'РАЗБОР ПРОВЕДЕТ УНИВЕРСАЛЬНЫЙ ЭКСПЕРТ',
      },
      {
        type: 'content',
        value: 'Задавай ему вопросы на любые темы:',
      },
      {
        type: 'content',
        value: 'поиск идей',
      },
      {
        type: 'content',
        value: 'достижение целей',
      },
      {
        type: 'content',
        value: 'маркетинг',
      },
      {
        type: 'content',
        value: 'продажи',
      },
      {
        type: 'content',
        value: 'подбор кадров',
      },
      {
        type: 'content',
        value: 'управление финансами',
      },
      {
        type: 'content',
        value: 'разработка стратегии',
      },
      {
        type: 'content',
        value: 'расширение бизнеса',
      },
    ],
  },
];
